import SVG from './image.svg';
import { face } from '~/notations';

export default {
  SVG,
  algorithm: [
    face.r.two,
    face.u.two,
    face.r.pri,
    face.u.two,
    face.r.two,
  ],
  name: 'Cross',
};
